<template>
  <div class="hello">

    <div class="aboutUsDiv">
        <div class="aboutUsImg">
            <span class="titleLeft">学为教育</span>
            <span class="titleRight">—— 改变一代人的学习方式</span>
        </div>

        <div class="aboutUsContent">
            <div class="contentTitle">关于我们</div>
            <div class="smallTitle">
                <div>公司简介</div>
                <div>COMPANY PROFILE</div>
            </div>
            <div class="aboutUsDetail">

                <div>
                    学为教育成立于2009年，经过十余年的不懈努力，目前下辖北京、沈阳、济南、西安、长沙、成都、南京、广州八个分公司，业务辐射超过27个省份，与全国1500多所顶尖中学建立了紧密的合作关系。
                </div>

                <div>
                    学为人以“教研引领未来，服务创造价值”为办学理念，坚持“厚德、明理、博学、创新”的校训，以“学而知不足，为而致不惑”为处事原则，以“精英培养精英”为课程精髓，立足高端，倾力打造“培优·顶尖”计划系列培养方案，覆盖高考、强基、竞赛和师训。
                </div>

                <div>
                    未来学为教育将以成为教育研发型企业为发展方向，努力为全国普通高中和教育主管部门提供教学内容和教学管理方案，悉力为拔尖创新人才的培养与骨干教师能力提升，贡献学为的智慧与力量。
                </div>

                <!-- <div>
                    学为教育集团成立于2009年，拥有北京学为教育科技有限公司、北京市海淀区学为培训学校、北京知播培优网络科技有限公司等三个发展平台，是以精准培养创新型精英人才为目标，专业致力于中、小学生课外辅导的教育平台。 
                </div>
                <div>
                    学为教育集团经过10年的不断拼搏，已经成为国内高考培优和自招辅导行业的领军企业，先后成功培训学生90余万人次，连续举办九届针对自主招生和全国卷高考的教师培训会，覆盖全国二十余省份1000多所优质高中。参加过学为培训的考生共有3400余人考入北京大学、清华大学，3700余人获得北京大学、清华大学自助招生降分优惠，40多万名考生获得其他“双一流”高校的降分优惠。
                </div>
                <div>
                    “学而知万卷书解百样惑，为以行千里路达一致途”是学为人孜孜不断的追求。学为人坚持“厚德、明理、博学、创新”的校训，以“学而知不足，为而致不惑”为办学理念，以“精英培养精英”为课程精髓，立足高端，打造出针对全国卷和自主招生考试的“培优·顶尖”、针对高中学科竞赛的“竞赛知播课堂”、针对北京卷的“北京高考状元班”和针对高中学生的“名师一对一”系列课程等多个尖端品牌。
                </div>

                <div>
                    目前，学为教育集团在原有业务基础上，努力实现向国际化、综合型教育集团的转型。在未来的征途上，学为人将协力同心，共图教育鸿业，把学为教育集团打造成“均衡教育资源，让每个孩子享受良好教育”的实践基地！
                </div>

                <div>
                    十年一剑、锋芒初现，宏愿不改，立志愈坚！
                </div> -->

            </div>


            <div class="detailBig">学校校训</div>
            <div class="detailSmall">厚德  明理  博学  创新</div>
            <div class="detailBig">办学理念</div>
            <div class="detailSmall">学而知不足  为而致不惑</div>
        </div>
    </div>


    

    

  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  data(){
    return {
      
    }

  },
  props: {

  }
}
</script>

<style scoped>
.aboutUsDiv {
    width: 1080px;
    margin: 0 auto;
}
.aboutUsImg {
    height: 140px;
    background: url("../assets/img/7.png") no-repeat;
    background-size: 100% 100%;
}
.titleLeft {
    font-size: 40px;
    color: #fff;
    font-weight: 700;
    line-height: 140px;
    margin-right: 20px;
}
.titleRight {
    font-size: 25px;
    color: #fff;
    font-weight: 700;
    line-height: 140px;
    /* letter-spacing: 2px; */ 
}
.aboutUsContent {
    width: 100%;
    border-top: 1px solid #333;
    margin-top: 50px;
    position: relative;
}
.contentTitle {
    width: 200px;
    text-align: center;
    line-height: 40px;
    position: absolute;
    background-color: #fff;
    top: -20px;
    left: 420px;
    font-weight: 700;
    font-size: 16px;
    letter-spacing: 2px;
}
.smallTitle {
    margin-top: 50px;
    padding-left: 5px;
    width: 180px;
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    border-left: 10px #C9C9C9 solid;
    border-bottom: 1px #C9C9C9 solid;
}
.smallTitle div {
    margin-bottom: 10px;
}
.aboutUsDetail div {
    margin-top: 30px;
    line-height: 30px;
    font-size: 14px;
    text-indent: 2em;
    text-align: left;
}
.detailBig {
    font-weight: 700;
    font-size: 16px;
    color: #333;
    text-align: left;
    line-height: 40px;
    margin-top: 40px;
}
.detailSmall {
    font-size: 14px;
    color: #666666;
    text-align: left;
    margin-bottom: 20px;
}




</style>
